import { helper } from '@ember/component/helper';

const DEFAULT_CURRENCY = 'EUR';
const EXPECTED_PARTS = 4;

/**
 * Ritorna il valore di valuta se valido, altrimenti EUR
 */
var defCurrency = helper(function defCurrency([value]) {
  if (!value || typeof value !== 'string') return DEFAULT_CURRENCY;
  const parts = value.split(',');
  return parts.length === EXPECTED_PARTS ? value : DEFAULT_CURRENCY;
});

export { defCurrency as default };
//# sourceMappingURL=def-currency.js.map
